import React, { Suspense } from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import { VStack, Spinner } from '@chakra-ui/react';
import {
  AdminsPage,
  PrestatairesPage,
  Dashboard,
  LoginPage,
  OrdersPage,
  PrivateRoute,
  ProductsPage,
  SingleOrderPage,
  SingleProductPage,
  CategoriesPage,
  HeroImagesPage,
  PlatformReviewsPage,
  OffersPage,
  CreateProductPage,
  EditProductPage,
  NotFoundPage,
} from './pages';

const PageFallback = () => (
  <VStack minH='100vh' alignItems='center' justifyContent='center'>
    <Spinner size='lg' color='brown.500' />
  </VStack>
);

function App() {
  return (
    <Router>
      <Suspense fallback={<PageFallback />}>
        <Switch>
          <PrivateRoute exact path='/'>
            <Dashboard />
          </PrivateRoute>
          <PrivateRoute exact path='/orders'>
            <OrdersPage />
          </PrivateRoute>
          <PrivateRoute exact path='/orders/:id'>
            <SingleOrderPage />
          </PrivateRoute>
          <PrivateRoute exact path='/products'>
            <ProductsPage />
          </PrivateRoute>
          <PrivateRoute exact path='/products/new'>
            <CreateProductPage />
          </PrivateRoute>
          <PrivateRoute exact path='/products/:id/edit'>
            <EditProductPage />
          </PrivateRoute>
          <PrivateRoute exact path='/products/:id'>
            <SingleProductPage />
          </PrivateRoute>
          <PrivateRoute exact path='/offers'>
            <OffersPage />
          </PrivateRoute>
          <PrivateRoute exact path='/categories'>
            <CategoriesPage />
          </PrivateRoute>
          <PrivateRoute exact path='/hero-images'>
            <HeroImagesPage />
          </PrivateRoute>
          <PrivateRoute exact path='/platform-reviews'>
            <PlatformReviewsPage />
          </PrivateRoute>
          <PrivateRoute exact path='/admins'>
            <AdminsPage />
          </PrivateRoute>
          <PrivateRoute exact path='/prestataires'>
            <PrestatairesPage />
          </PrivateRoute>
          <PrivateRoute exact path='/login'>
            <LoginPage />
          </PrivateRoute>
          <Route>
            <NotFoundPage />
          </Route>
        </Switch>
      </Suspense>
    </Router>
  );
}

export default App;
